type Args = {
  path: string;
  value: unknown;
  source?: Record<string, unknown>;
};
/**
 * @example
 * ```ts
 * const source = {
 *  user: {
 *    profile: {
 *      name: 'John Doe'
 *    }
 *  }
 * };
 *
 * const updatedSource = setObjectFieldByPath({
 *  path: 'user.profile.name',
 *  value: 'Jane Doe',
 *  source
 * });
 * ```
 *
 * @returns
 * Output: { user: { profile: { name: 'Jane Doe' } } }
 *
 */
const setObjectFieldByPath = ({ path, value, source }: Args): object => {
  if (!path) {
    throw new Error('Path cannot be empty');
  }

  const segments = path.split('.');
  const updatedSource = source ? { ...source } : {};
  let current = updatedSource;

  segments.forEach((segment, index) => {
    if (index === segments.length - 1) {
      current[segment] = value;
    } else {
      if (!current[segment] || typeof current[segment] !== 'object') {
        current[segment] = {};
      }
      current = current[segment] as Record<string, unknown>;
    }
  });

  return updatedSource;
};

export default setObjectFieldByPath;
